import React from 'react';

export const SetupHelp = ({className = "setupHelp helpPolicyLinks"}) => (
  <div className={className}>Need help? <a href={'mailto:qube@seeq.com'}>Contact us</a>
    {' · '}
    <a href="/privacy" target="_blank" rel="noreferrer">Privacy Policy</a>
  </div>
);
